import { memo } from 'react';
import type { ProductVehicle } from '../types';
import VehiclesTable from './ProductDetails/ProductTables/VehiclesTable';

const MotorcycleSearchTable = ({
    motorcycles,
    onModelChange,
}: {
    motorcycles: ProductVehicle[];
    onModelChange: (vehicleId: string) => void;
}) => {
    const showTypeColumn =
        Array.from(motorcycles).some(vehicle => !!vehicle.typeNumbers.length) ||
        motorcycles.length === 0;

    return (
        <VehiclesTable
            showTypeColumn={showTypeColumn}
            vehicles={motorcycles}
            onModelChange={onModelChange}
        />
    );
};

export default memo(MotorcycleSearchTable);
